import React from 'react';
import { useFormField } from '../../useFormField';
import { type AutocompleteOptionType } from '@generated';
import { AutocompleteSearchField, type AutocompleteSearchFieldProps } from '../base-fields/AutocompleteSearchField';
import type { StripControlledProperties } from '../../types';

export interface AutocompleteSearchFormFieldProps<K extends AutocompleteOptionType>
	extends StripControlledProperties<AutocompleteSearchFieldProps<K>> {
	name: string;
}

export function AutocompleteSearchFormField<K extends AutocompleteOptionType>(props: AutocompleteSearchFormFieldProps<K>) {
	const fieldProps = useFormField<string | null>({ ...props, validateOnChange: true });
	return <AutocompleteSearchField<K> {...props} {...fieldProps} selectedKey={fieldProps.value} allowsEmptyCollection />;
}
